import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { SeasonMatchesContext } from 'projectSpecific/sports/cnr/contexts/SeasonMatchesContext'
import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions'
import { useContext } from 'react'
import { MatchesSchedule } from './MatchesSchedule'

export const TeamSchedule = ({ matchDisplayType, matchScheduleDisplayType, teamKey }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state } = states ?? {};
  const { pathViews } = paps_state ?? {};

  const { _matchDisplayType, _matchDisplayOptions } = useMatchScheduleOptions({ matchScheduleDisplayType })

  return <MatchesSchedule
    matchScheduleDisplayType={matchScheduleDisplayType}
    teamKey={teamKey || pathViews.teams}
    matchDisplayOptions={_matchDisplayOptions}
    matchDisplayType={_matchDisplayType}
  />

}
